import type { ServiceItem } from '../types';

export const services: ServiceItem[] = [
  {
    id: 'rehvivahetus',
    title: 'Rehvivahetus',
    description:
      'Hooajaline ja vajaduspõhine rehvivahetus sõiduautodele ning kaubikutele/maasturitele.',
    icon: 'circle-dot',
    calculatorMode: 'tire',
    image: '/images/rehvivahetus.webp',
    // Full right crop on desktop side frame
    imagePosition: '100% center',
  },
  {
    id: 'diagnostika',
    title: 'Diagnostika',
    description:
      'Veaotsing ja süsteemide kontroll.',
    icon: 'gauge',
    calculatorMode: 'hourly',
    hourlyServiceId: 'diagnostika',
    image: '/images/diagnostika.webp',
  },
  {
    id: 'remont',
    title: 'Remonditööd',
    description:
      'Mehaaniline remont alates veermikust kuni mootorini.',
    icon: 'wrench',
    calculatorMode: 'hourly',
    hourlyServiceId: 'remont',
    image: '/images/remonditood.webp',
  },
  {
    id: 'olivahetus',
    title: 'Õlivahetus',
    description: 'Õli + filter vahetus; hoiab mootorit ja pikendab eluiga.',
    icon: 'droplets',
    calculatorMode: 'fixed',
    image: '/images/olivahetus.webp',
    // Shift crop 20% right of center (50% → 70%)
    imagePosition: '70% center',
  },
  {
    id: 'veakoodid',
    title: 'Veakoodide lugemine',
    description: 'Kiire veakoodide väljalugemine enne suuremat tööd.',
    icon: 'scan-search',
    calculatorMode: 'fixed',
    image: '/images/veakoodid.webp',
    // Shift crop 20% right of center (50% → 70%)
    imagePosition: '70% center',
  },
  {
    id: 'hooldus',
    title: 'Hooldus ja ülevaatus',
    description:
      'Korrapärane hooldus ja veermiku ülevaatus sõiduohutuse heaks.',
    icon: 'clipboard-check',
    calculatorMode: 'hourly',
    hourlyServiceId: 'remont',
    image: '/images/hooldus.webp',
    // Shift crop 20% left of center (50% → 30%)
    imagePosition: '30% center',
  },
];

